import React, { ComponentProps, useState } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import { Option, Select } from '../../../_lib/Form2';
import { useHtmlValidId } from '../../../hooks/useHtmlValidId';
import ContentMessage from '../../../_lib/components/ContentMessage/ContentMessage';
import { FooterLink } from '../../../components/molecules/FooterLink/FooterLink';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { Calendar } from '../partials/calendar/Calendar';
import { EventType } from '../CalendarTypes';

type CalendarType = {
  id: string;
  title: string;
  url: string;
  events: EventType[];
};

export type CalendarDefaultViewProps = { calendars: CalendarType[]; calendarRangeStart: Date; calendarRangeEnd: Date };

export function CalendarDefault({ calendars, calendarRangeStart, calendarRangeEnd }: CalendarDefaultViewProps) {
  const { t } = useSonTranslation('Calendar');
  const eventListId = useHtmlValidId();

  const localCalendar = calendars && calendars.length > 0 ? calendars[0] : null;

  const [activeCalendar, setActiveCalendar] = useState<CalendarType | null>(localCalendar);

  if (!localCalendar) {
    return <ContentMessage text={t('noCalendarAdded')} />;
  }

  const setActiveCalendarById = (id: string) => {
    const foundCalendar = calendars?.find((calendar: CalendarType) => calendar.id === id);
    if (foundCalendar) {
      setActiveCalendar(foundCalendar);
    }
  };

  return (
    <>
      <div className="calendar__select">
        <Select
          key={calendars.length}
          label={t('select')}
          labelHidden
          aria-controls={eventListId}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => setActiveCalendarById(e.target.value)}
        >
          {calendars.map(calendar => (
            <Option key={calendar.id} value={calendar.id}>
              {calendar.title}
            </Option>
          ))}
        </Select>
      </div>
      {activeCalendar
        ? (
            <Calendar
              events={activeCalendar?.events}
              title={activeCalendar?.title}
              eventListId={eventListId}
              calendarRangeStart={calendarRangeStart}
              calendarRangeEnd={calendarRangeEnd}
            />
          )
        : null}
      {activeCalendar
        ? (
            <FooterLink footerButtonLabel={t('footerButton')} footerLink={{ url: activeCalendar.url }} />
          )
        : null}
    </>
  );
}
export const CalendarDefaultView = asView(CalendarDefault);
export type CalendarDefaultView = ComponentProps<typeof CalendarDefaultView>;
